module.exports = __webpack_public_path__ + "img/a-active.70b855a6.png";